
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import defectList from './defectList.vue';

    interface State {
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        listSumNumber: number;
        importantNumber: number;
        listNormalNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "WaterCheck",
        setup() {
            let state: State = reactive({
                defectList: [],
                listName: '泡水检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                listNormalNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {soakWater} = data;
                const {importantItemCount,defectItemCount,itemCount,itemList,itemTitle} = soakWater
                state.defectList = itemList
                state.listName = itemTitle
                state.listDefectNumber = defectItemCount
                state.importantNumber = importantItemCount
                state.listSumNumber = itemCount
                state.listNormalNumber = itemCount - defectItemCount
            })
            return {
                state
            }
        },
        components: {
            defectList
        }
    })
